import { grey } from "@faro-lotv/flat-ui";
import { GUID } from "@faro-lotv/foundation";

/** The width of the connection lines. */
export const LINE_WIDTH = 5;

/** How PartOf edges should differ in size to regular registration edges. */
export const PART_OF_SIZE_FACTOR = 0.5;

/** The color of connection line when user chooses quality color to be disabled */
export const DISABLED_QUALITY_COLOR = grey[700];

/** The color of connection line whose quality is not known */
export const UNKNOWN_QUALITY_COLOR = grey[700];

/** A connection between two scans. */
export type ScanConnection = {
  /** The ID of the source scan. */
  sourceId: GUID;
  /** The ID of the target scan. */
  targetId: GUID;
};

/**
 * @param connection1 The first connection
 * @param connection2 The second connection
 * @returns `true` if the connections connect the same scans (in any direction), else `false`.
 */
export function areConnectionsEqual(
  connection1: ScanConnection,
  connection2: ScanConnection,
): boolean {
  return (
    (connection1.sourceId === connection2.sourceId &&
      connection1.targetId === connection2.targetId) ||
    (connection1.sourceId === connection2.targetId &&
      connection1.targetId === connection2.sourceId)
  );
}
